import React from 'react';
import PropTypes from 'prop-types';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import Tooltip from '@mui/material/Tooltip';
import { Box, styled } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';

const StyledPriorityHighIcon = styled(PriorityHighIcon)(({ theme }) => ({
  position: 'absolute',
  left: theme.spacing(-3.5),
  top: theme.spacing(2)
}));

const DetailedTextField = ({ defaultValue, value, auxiliaryInfo, error, ...rest }) => {
  return (
    <Box sx={{ position: 'relative' }}>
      {defaultValue !== null
        ? value !== defaultValue &&
          (!error ? (
            <Tooltip title={auxiliaryInfo}>
              <StyledPriorityHighIcon color='primary' />
            </Tooltip>
          ) : (
            <Tooltip title={auxiliaryInfo}>
              <StyledPriorityHighIcon color='error' />
            </Tooltip>
          ))
        : ''}
      <TextField value={value} defaultValue={defaultValue} error={error} {...rest} />
    </Box>
  );
};

DetailedTextField.propTypes = {
  defaultValue: PropTypes.number,
  value: PropTypes.number,
  error: PropTypes.bool.isRequired,
  auxiliaryInfo: PropTypes.string
};

export default DetailedTextField;
